import { ControlledMenu, MenuItem, useMenuState } from "@szhsin/react-menu";
import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableCell } from "@mui/material";
import useStore from "../../store";

export default function TableCellContext(props) {
    const {
        children, onContextSelect, field, style, disableContext, onClick,
    } = props;
    const ref = useRef(null);

    const [menuProps, toggleMenu] = useMenuState();

    const darkMode = useStore((store) => store.app.darkMode);

    const handleHeaderContextMenu = (event) => {
        event.preventDefault();
        toggleMenu(true);
    };
    return (
        <TableCell ref={ref} onClick={onClick} onContextMenu={!disableContext ? handleHeaderContextMenu : undefined} style={{ ...style }}>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <ControlledMenu {...menuProps} anchorRef={ref} onClose={() => toggleMenu(false)} portal direction="bottom" theming={darkMode ? "dark" : null}>
                <MenuItem onClick={() => onContextSelect("editColumns", { field })}>
                    <FontAwesomeIcon icon="columns" fixedWidth />
                    Spalten bearbeiten
                </MenuItem>
            </ControlledMenu>
            {children}
        </TableCell>
    );
}
